const MAX_STRING_LENGTH = 2048;

export function truncateString(s: string): string {
  if (typeof s !== 'string') return s as any;
  return s.length > MAX_STRING_LENGTH ? s.slice(0, MAX_STRING_LENGTH) : s;
}

export function sanitizePayload(value: any, seen = new WeakSet()): any {
  if (value === null || value === undefined) return undefined;

  if (typeof value === 'string') return truncateString(value);
  if (typeof value === 'number' || typeof value === 'boolean') return value;
  if (typeof value === 'function') return undefined;
  if (typeof value === 'symbol') return String(value);
  if (value instanceof Error) {
    return {
      name: value.name,
      message: truncateString(value.message),
      stack: typeof value.stack === 'string' ? truncateString(value.stack) : undefined,
    };
  }
  if (typeof value === 'object') {
    if (seen.has(value)) return '[Circular]';
    seen.add(value);

    if (Array.isArray(value)) {
      return value.map((v) => sanitizePayload(v, seen)).filter((v) => v !== undefined);
    }

    const out: Record<string, any> = {};
    for (const [k, v] of Object.entries(value)) {
      const sv = sanitizePayload(v, seen);
      if (sv !== undefined) out[k] = sv;
    }
    return out;
  }
  // Fallback
  try {
    return JSON.parse(JSON.stringify(value));
  } catch {
    return String(value);
  }
}

export function byteSizeOfJson(obj: any): number {
  try {
    return new TextEncoder().encode(JSON.stringify(obj)).length;
  } catch {
    try {
      return JSON.stringify(obj).length; // rough fallback
    } catch {
      return 0;
    }
  }
}

export function nowTsMs(): number {
  return Date.now();
}

export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

